import { getQueryString } from '@common/utils/dom'
import { LANGUAGE_MAP, URL_CONFIG } from './constant'

/**
 * 获取链接地址
 * @param type 链接类型
 * @returns 返回链接地址字符串
 */
export function getLinkUrl(type) {
  const config = URL_CONFIG[location.hostname] || URL_CONFIG['home.mi.com']
  const currentCountryCode = getQueryString('countryCode')
  const url = new URL(`${location.origin || 'https://home.mi.com'}${config[type]}`)
  
  // 添加当前的语言参数（没有则默认zh）、地区代号参数（如有）
  url.searchParams.set('locale', getQueryString('locale') || 'zh')
  currentCountryCode && url.searchParams.set('countryCode', getQueryString('countryCode'))
  isNewPrivacy() && url.searchParams.set('version', 'latest')
  return url.toString()
}

function isNewPrivacy() {
  const version = getQueryString('version')
  if (!version) return true
  const arr = version.split('.')
  const [a1, a2] = arr
  return (a1 === 9 && a2 >= 9) || a1 > 9
}

/**
 * 根据当前的语言, 获取对应的所有文本
 * @param {*} language 
 * @returns 
 */
export function getLanguageText(language) {
  const result = LANGUAGE_MAP[language]
  if (!result) {
    // 默认返回中文
    return LANGUAGE_MAP.zh_cn
  }
  return result
}
